/**
 * The one map from a task's `kind` to its display key. Add a kind here and every surface
 * follows — the register, the board, the detail, the create drawer, the filter bar, the
 * generate drawer, the hierarchy and the root `/tasks` page all read this.
 */

import type { MessageKeys } from '@/lib/i18n';

import type { TaskKind } from './api';

export const KIND_KEY: Readonly<Record<TaskKind, MessageKeys['tasks']>> = {
  task: 'kind.task',
  issue: 'kind.issue',
  question: 'kind.question',
};
